import { Link } from "react-router-dom";
import { setCanonical, setPageTitle } from "@/utils/seo";
import { useEffect } from "react";

export default function DisclaimerPage() {
  useEffect(() => {
    setCanonical("/disclaimer");
    setPageTitle("Disclaimer & Affiliate Disclosure");
  }, []);

  return (
    <div className="container-main max-w-3xl py-12 md:py-16" data-testid="disclaimer-page">
      <div className="flex items-center gap-2 text-xs text-slate-500 mb-8">
        <Link to="/" className="hover:text-slate-700 no-underline">Home</Link><span>/</span>
        <span className="text-slate-700">Disclaimer & Affiliate Disclosure</span>
      </div>

      <h1 className="text-3xl font-extrabold text-slate-900 mb-6">Disclaimer & Affiliate Disclosure</h1>
      <p className="text-sm text-slate-400 mb-8">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <div className="prose prose-slate max-w-none text-sm text-slate-600 space-y-6">
        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6">Financial Disclaimer</h2>
          <p>The information provided on AffordScope.com is for general informational and educational purposes only. It is <strong>not financial advice</strong>.</p>
          <p>All salary calculations, tax estimates, cost of living data, rent figures, and affordability verdicts displayed on this website are <strong>approximations and estimates</strong>. Actual costs, taxes, and expenses may vary significantly based on individual circumstances, location specifics, time of year, and many other factors.</p>
          <p>You should <strong>not</strong> make any financial decisions (including but not limited to relocation, salary negotiation, budgeting, or housing choices) based solely on the information provided by AffordScope. Always consult with a qualified financial advisor, tax professional, or other appropriate professional before making significant financial decisions.</p>
          <p>AffordScope, its owners, and contributors shall not be held liable for any losses or damages arising from the use of information provided on this website.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6">Affiliate Disclosure</h2>
          <p>AffordScope.com participates in affiliate marketing programs. This means we may receive commissions when you click on certain links on our site and make a purchase or sign up for a service.</p>
          <p>These affiliate relationships include, but are not limited to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Credit card comparison and referral programs</li>
            <li>Banking and savings account partnerships</li>
            <li>Financial planning and budgeting tool referrals</li>
            <li>Sponsored content and banner advertisements</li>
          </ul>
          <p>The presence of affiliate links does not influence our content, calculations, or recommendations. We only partner with services we believe may be genuinely useful to our users.</p>
          <p>When you see labels such as "Sponsored", "Sponsored Partners", "Advertisement", or "Affiliate" on our site, these indicate paid placements or affiliate relationships.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6">Advertising Disclosure</h2>
          <p>AffordScope displays advertisements through Google AdSense and direct advertising partnerships. These advertisements are clearly marked and do not affect our editorial content or calculations.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6">AI Chatbot Disclosure</h2>
          <p>Sarah is an AI-powered assistant. Responses generated by Sarah are for informational purposes only and do not constitute financial advice. Sarah may occasionally provide inaccurate information. Always verify important financial information with qualified professionals.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6">Data Accuracy</h2>
          <p>We strive to keep our cost of living data, rent estimates, and tax calculations as current and accurate as possible. However, data may be outdated or imprecise. Tax calculations use 2025 federal tax brackets, FICA rates, and state income tax rates that may not reflect recent changes or your specific tax situation.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6">Contact</h2>
          <p>For questions about this disclaimer or our affiliate relationships, contact us at <a href="mailto:support@lifeownit.com" className="text-emerald-600 hover:underline">support@lifeownit.com</a>.</p>
        </section>
      </div>
    </div>
  );
}
